import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import FAQ from "./pages/FAQ";
import Projects from "./pages/Project";
import Brochures from "./pages/Brochures";
import Leadership from "./pages/Leadership";
import Contact from "./pages/Contact";
import ServicePage from "./pages/ServicePage";
import Error404 from "./pages/Error404"; // Error Page
import RPT from "./pages/RecentPage";
import Site from "./pages/Site";
import About from "./pages/About";
import Carrers from "./pages/Carrers";
const App = () => {
  return (
    
    <Router>
      <Navbar />
      <Routes>
        {/* Define all the routes */}
        <Route path="/" element={<Home />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/carrers" element={<Carrers />} />
        <Route path="/brochures" element={<Brochures />} />
        <Route path="/leadership" element={<Leadership />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/servicepage" element={<ServicePage />} />
        <Route path="/RecentProject" element={<RPT />} />
        <Route path="/Site" element={<Site />} />
        <Route path="/Breakthrough" element={<About />} />
        {/* Dynamic Project Page */}
        <Route path="/Project/:service/:projectTitle" element={<Projects />} />
        {/* Catch-all for undefined routes */}
        <Route path="*" element={<Error404 />} />
      </Routes>
      <Footer />

    </Router>
  );
};

export default App;
